import { locationAgreedAtom, userLatLonAtom } from '@atoms/locationAtoms';
import Column from '@components/Column';
import Map from '@components/Map';
import styled from '@emotion/styled';
import useShop from '@hooks/shop/useShop';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useAtomValue } from 'jotai';
import { useMemo } from 'react';

import CloseHeader from './components/CloseHeader';
import OrderNotice from './components/OrderNotice';
import SheetFooter from './components/SheetFooter';
import ShopInfo from './components/ShopInfo';

interface Params {
    shopId: string;
    lat?: number;
    lng?: number;
}

declare module '@stackflow/config' {
    interface Register {
        ShopLocationBottomSheet: Params;
    }
}

const ShopLocationBottomSheet:ActivityComponentType<'ShopLocationBottomSheet'> = ({ params }) => {
    const {
        shopId, lat, lng,
    } = params;
    const shop = useShop(shopId);
    const { pop, push } = useFlow();
    const location = useAtomValue(userLatLonAtom);
    const locationAgreed = useAtomValue(locationAgreedAtom);
    // 위치 정보가 있을 때만 내 위치 마커와 위치 버튼을 표시
    const hasMyLocation = locationAgreed && location.lat !== 0;
    const shopLocation = useMemo(() => ({ lat: lat!, lng: lng! }), [lat, lng]);
    const myLocation = useMemo(
        () => (hasMyLocation ? { lat: location.lat, lng: location.lon } : shopLocation),
        [hasMyLocation, location.lat, location.lon, shopLocation],
    );
    const markers = useMemo(() => (shop ? [{
        ...shopLocation, name: shop.name, id: shop.id, isMyShop: shop.isMyShop,
    }] : []), [shop, shopLocation]);
    const handleOrderButtonClick = () => {
        pop();
        push('ItemsActivity', { shopId, type: 'ALL' });
    };
    return (
        <BottomSheet>
            <CloseHeader onClose={pop}/>
            {shop && (
                <Map center={shopLocation}
                    myLocation={myLocation}
                    showMyLocation={hasMyLocation}
                    width='100%'
                    height={285}
                    markers={markers} />
            )}
            <Contents fullWidth align='center' spacing={4}>
                <ShopInfo shop={shop}/>
                <OrderNotice/>
            </Contents>
            {shop && (
                <SheetFooter shop={shop}
                    onOrder={handleOrderButtonClick}/>
            )}
        </BottomSheet>
    );
};

const Contents = styled(Column)`
    padding: var(--spacing-4);
`;

export default ShopLocationBottomSheet;
